import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-inlinemessage',
    templateUrl: './inlinemessage.component.html',
    styleUrls: ['./inlinemessage.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InlinemessageComponent {

  @Input() level = 'info';
  @Input() message = '';

}
